export default __webpack_public_path__ + "static/media/grs_1.c823df1c.jpg";